export default __webpack_public_path__ + "static/media/Logo_600x200.7847b12f.png";